import useWorkflowLogs from "backend/hooks/workflows/useWorkflowLogs";
import MeasureTable from "design/components/tables/MeasureTable";
import ExecutiveDashboardTitle from "design/components/texts/ExecutiveDashboardTitle";
import React from "react";
import { formatWFStatus } from "utils/utils";

const WorkflowLogs = (props: { workflowId?: string }) => {
  const { data: logs, isLoading: isLogsLoading } = useWorkflowLogs(
    props.workflowId
  );

  if (!logs) return null;
  return (
    <>
      {logs ? (
        <>
          <ExecutiveDashboardTitle>Audit Log</ExecutiveDashboardTitle>
          <MeasureTable
            items={logs || []}
            columns={[
              {
                title: "User",
                value: (row) => <div>{row.elem.username}</div>,
              },
              {
                title: "Previous State",
                value: (row) => <div>{formatWFStatus(row.elem.prevstate)}</div>,
              },
              {
                title: "New State",
                value: (row) => <div>{formatWFStatus(row.elem.newstate)}</div>,
              },
              {
                title: "Date",
                value: (row) => (
                  <div>{new Date(row.elem.timestamp).toLocaleString()}</div>
                ),
              },
              {
                title: "Message",
                value: (row) => <div>{row.elem.message}</div>,
              },
            ]}
          />
        </>
      ) : null}
    </>
  );
};

export default WorkflowLogs;
